module.exports = __webpack_public_path__ + "static/media/Bar.f1f75f46.png";